module.exports = __webpack_public_path__ + "img/novo.2b7ac322.png";